import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { AvForm } from 'availity-reactstrap-validation';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../components/Common/iComponents/iPopUp/IpopUp';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';
import { Label, FormGroup, Input } from 'reactstrap';
import { ISwitch } from '../../components/Common/iComponents/iSwitch/iSwitch';

const FormClient = ({
  selectedRow,
  onCreateClient,
  onUpdateClient,
  onDeleteClients,
  onCancel,
}: any) => {
  const arrayUpdAdd = [
    'name',
    'email',
    'company',
    'description',
    'logo',
    'logoSmall',
    'enabled',
    'primaryColor',
    'secondaryColor',
    'primaryDarkColor',
    'secondaryDarkColor',
    'sidebarBgColor',
    'headerBgColor',
    'headerDarkBgColor',
  ];
  const columsPop = 2;
  const toggleField = 'enabled';
  const [form, setForm] = useState({
    [toggleField]: false,
    name: '',
    email: '',
    company: '',
    description: '',
  });
  const [flag, setflag] = useState<any>(true);

  useEffect(() => {
    if (selectedRow) {
      setForm(selectedRow);
    }
  }, [selectedRow]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };

  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            type="button"
            className="btn-delete"
            onClick={() => onDeleteClients(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateClient(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateClient(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const {
      name,
      email,
      company, 
    } = form;
    if (
      name != '' &&
      email != '' &&
      company != ''
    ) {
      setflag(false);
    } else {
      setflag(true);
    }
  }, [form]);
  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };
  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  return (
    <>
      <div style={{ width: '650px', height: '450px', overflow: 'auto' }}>
        <AvForm
          className="custom-form mt-0"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
            gridAutoRows: 'minmax(10%, 90px)',
            gridGap: '2%',
            padding: '0',
            marginLeft: '5%',
            marginRight: '5%',
            paddingTop: '2%',
          }}
        >
          {arrayUpdAdd?.map((val: any) => {
            const firstLet = val[0].toUpperCase();
            const rest = val.slice(1);
            const word = firstLet + rest;
            const nameObject = val as keyof typeof form;
            const temp = form[nameObject];
            const valid = temp ? true : false;
            const type = val === 'company' ? 'number' : '';
            const value = selectedRow ? itemVals(val, selectedRow) : null;
            const readonly = val === 'logo' || val === 'logoSmall' ? true : false;
            if (val === toggleField) {
              return (
                <FormGroup className="text-center">
                  <div className="text-capitalize">
                    <Label>{val}</Label>
                  </div>
                  <Label>
                    <ISwitch
                      title={val}
                      checked={Boolean(form[nameObject])}
                      onChangeBooleanHandler={onChangeBooleanHandler}
                    />
                  </Label>
                </FormGroup>
              );
            } else if (
              val === 'name' ||
              val === 'email' ||
              val === 'company' ||
              val === 'description' ||
              (val === 'logo' && value) ||
              (val === 'logoSmall' && value) 
            ) {
              return (
                <IInput
                  title={val}
                  valid={valid}
                  value={value}
                  type={type}
                  readonly={readonly}
                  onChangeHandler={onChangeHandler}
                />
              );
            } else {
              return (
                value ? (
                  <div style={{ marginTop: '-1%' }}>
                    <Label htmlFor="example-color-input" className="form-Label">
                      {val}
                    </Label>
                    <Input
                      type="color"
                      className="form-control form-control-color mw-100"
                      id="example-color-input"
                      value={itemVals(val, form)}
                      title="Choose your color"
                      style={{ padding: '1.5px' }}
                      onChange={(e: any) => {
                        const n = val;
                        setForm({
                          ...form,
                          [n]: e.target.value,
                        });
                      }}
                    />
                  </div>
                ) : null
              );
            }
          })}
        </AvForm>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1%',
          marginRight: '6%',
        }}
      >
        {renderButtons()}
      </div>
    </>
  );
};

FormClient.propTypes = {
  selectedRow: PropTypes.object,
  onCreateClient: PropTypes.func,
  onUpdateClient: PropTypes.func,
  onDeleteClients: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormClient;
